import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const ThemeContext = createContext(null);

const applyTheme = (data) => {
    if (!data) return;
    const root = document.documentElement;
    const groups = ["colors", "typography", "radius", "shadows", "animations"];
    groups.forEach((g) => {
        const obj = data[g] || {};
        Object.entries(obj).forEach(([k, v]) => {
            root.style.setProperty(k, v);
        });
    });
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(null);

    const load = useCallback(async () => {
        try {
            const res = await api.get("/theme");
            setTheme(res.data);
            applyTheme(res.data);
        } catch {}
    }, []);

    useEffect(() => { load(); }, [load]);

    const updateTheme = async (data) => {
        await api.put("/admin/theme", data);
        setTheme(data);
        applyTheme(data);
    };

    return (
        <ThemeContext.Provider value={{ theme, updateTheme, reload: load }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
